import PageHeader from "../components/PageHeader";
import EmptyState from "../components/EmptyState";

export default function TasksPage({ tasks, leadership }) {
  return (
    <>
      <PageHeader eyebrow="Accountability" title="Open Tasks" description={leadership ? "Outstanding checklist work across the team." : "Your outstanding transaction work."} />
      <section className="panel table-panel">
        {tasks.length ? <div className="responsive-table"><table>
          <thead><tr><th>Task</th><th>Property</th><th>Owner</th><th>Due</th><th>Status</th></tr></thead>
          <tbody>{tasks.map(task => <tr key={task.id}>
            <td data-label="Task">{task.title}</td><td data-label="Property">{task.propertyAddress}</td><td data-label="Owner">{task.ownerName}</td><td data-label="Due">{task.dueDate}</td><td data-label="Status">{task.status}</td>
          </tr>)}</tbody>
        </table></div> : <EmptyState>No open tasks.</EmptyState>}
      </section>
    </>
  );
}
